import * as braintree from 'braintree-web';
import { BRAINTREE_STYLES, BRAINTREE_FIELD_CONFIG, VENMO_CONFIG } from '../constants/braintree';

class BraintreeService {
  private clientInstance: braintree.Client | null = null;

  async createClient(authorization: string): Promise<braintree.Client> {
    if (this.clientInstance) {
      return this.clientInstance;
    }

    this.clientInstance = await braintree.client.create({ authorization });
    return this.clientInstance;
  }

  async createHostedFields(
    authorization: string,
    styles?: Record<string, Record<string, string>>,
    fields?: Record<string, { selector: string; placeholder: string }>
  ): Promise<braintree.HostedFields> {
    const client = await this.createClient(authorization);

    return await braintree.hostedFields.create({
      client,
      styles: styles || BRAINTREE_STYLES,
      fields: fields || BRAINTREE_FIELD_CONFIG,
    });
  }

  async createVenmoClient(authorization: string, profileId?: string): Promise<braintree.Venmo> {
    const client = await this.createClient(authorization);

    return await braintree.venmo.create({
      ...VENMO_CONFIG,
      client,
      ...(profileId && { profileId }),
    });
  }

  async createBraintreeDataCollector(authorization: string): Promise<braintree.DataCollector> {
    const client = await this.createClient(authorization);

    return await braintree.dataCollector.create({
      client,
      kount: true,
    });
  }

  async createPayPalClient(authorization: string): Promise<braintree.PayPal> {
    const client = await this.createClient(authorization);

    return await braintree.paypal.create({
      client,
    });
  }

  async teardownHostedFields(hostedFields: braintree.HostedFields | null): Promise<void> {
    if (!hostedFields) return;

    try {
      await hostedFields.teardown();
    } catch (error) {
      console.error('Error tearing down Hosted Fields:', error);
    }
  }

  reset(): void {
    this.clientInstance = null;
  }
}

export const braintreeService = new BraintreeService();
